import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DIALOG_MODE_IDENTIFIER, IoniconsOutline } from '@pt/pt-models';
import { Observable } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { AsyncPipe, NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SafeTemplatePipe } from '@pt/pipes';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'pt-help-tooltip',
  standalone: true,
  template: `
    <div class='modal-header'>
      <div class='modal-title h4'>
        <ion-icon name='{{IconHelp}}' [ngStyle]="{'font-size': '24px'}" class='ion-icon' title=''></ion-icon>
        <span class="ms-1">{{ title | async }}</span>
      </div>
      <button type='button' class='btn-close' aria-label='Close' (click)='activeModal.dismiss()'>
      </button>
    </div>
    <div class='modal-body modal-body-help'
         [innerHTML]='outputValue'>
    </div>
    <div class='modal-footer'>
      <button ngbAutofocus type='button' class='btn btn-primary btn-sm'
              (click)='onClose()'>
        {{ 'BUTTON.CLOSE' | translate }}
      </button>
    </div>
  `,
  imports: [
    IonicModule,
    NgStyle,
    AsyncPipe,
    SafeTemplatePipe,
    TranslateModule,
    SafeTemplatePipe
  ],
  styles: [`
    .modal-body-help {
      max-height: 500px;
      overflow-y: auto;
    }

    .modal-body-help::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    .modal-body-help::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    .modal-body-help::-webkit-scrollbar-thumb {
      background: #888;
    }

    .modal-body-help::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  `]
})
export class HelpTooltipDialogComponent {

  title!: Observable<string>;
  value?: string;

  IconHelp = IoniconsOutline.infoCircle;
  public outputValue: any;

  constructor(public activeModal: NgbActiveModal, private sanitizer: DomSanitizer) {
  }

  run(title: Observable<string>, value?: string) {
    this.title = title;
    this.value = value;
    if (this.value) {
      this.outputValue = this.sanitizer.bypassSecurityTrustHtml(this.value.replace(DIALOG_MODE_IDENTIFIER, ''));
    } else {
      this.outputValue = '';
    }
  }

  public stripDialogIdentifier() {
    return this.value?.replace(DIALOG_MODE_IDENTIFIER, '');
  }

  onClose() {
    this.activeModal.close(false);
  }
}

